import { client } from "../dtos/Client";
import { Observable } from "rxjs/Observable";
import "rxjs/add/observable/from";
import * as Dtos from "../dtos/Tmd.dtos";

export const groupFinanceApi = {
    getGroupFinanceByGroupId: (groupId: number): Observable<Dtos.GetGroupFinanceByGroupIdResponse> => {
        //Create the request.
        let request: Dtos.GetGroupFinanceByGroupId = new Dtos.GetGroupFinanceByGroupId();
        request.groupId = groupId;

        //Send request.
        const response: Promise<Dtos.GetGroupFinanceByGroupIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    getGroupFinanceById: (id: number): Observable<Dtos.GetGroupFinanceByIdResponse> => {
        //Create the request.
        let request: Dtos.GetGroupFinanceById = new Dtos.GetGroupFinanceById();

        request.id = id;

        //Send request.
        const response: Promise<Dtos.GetGroupFinanceByIdResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    setGroupFinance: (groupFinance: Dtos.GroupFinance): Observable<Dtos.SetGroupFinanceResponse> => {

        let request: Dtos.SetGroupFinance = new Dtos.SetGroupFinance();

        request.groupFinance = groupFinance;

        // send request
        const response: Promise<Dtos.SetGroupFinanceResponse> = client.post(request);

        return Observable.from(response);
    },
    createGroupFinance: (groupId: number): Observable<Dtos.CreateGroupFinanceResponse> => {
        //Create the request.
        let request: Dtos.CreateGroupFinance = new Dtos.CreateGroupFinance();

        request.groupId = groupId;

        //Send request.
        const response: Promise<Dtos.CreateGroupFinanceResponse> = client.get(request);

        //Return request observable (incomplete request, still processing).
        return Observable.from(response);
    },
    validateGroupFinance: (groupFinance: Dtos.GroupFinance): Observable<Dtos.ValidateGroupFinanceResponse> => {

        let request: Dtos.ValidateGroupFinance = new Dtos.ValidateGroupFinance();

        request.groupFinance = groupFinance;

        // send request
        const response: Promise<Dtos.ValidateGroupFinanceResponse> = client.post(request);

        return Observable.from(response);
    },
}